import { render } from "./CorpCard.vue?vue&type=template&id=3d29f085&scoped=true&ts=true"
import script from "./corpCardHelper.ts?vue&type=script&lang=ts"
export * from "./corpCardHelper.ts?vue&type=script&lang=ts"

import "./CorpCard.vue?vue&type=style&index=0&id=3d29f085&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d29f085"]])

export default __exports__